import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Segment } from 'semantic-ui-react';
import { PermitFormValues } from '../../../../app/models/permit';
import { useStore } from '../../../../app/stores/store';
import PermitFormSteps from './PermitFormSteps';

export default observer(function PermitForm() {
    const {permitStore} = useStore();
    const {
        createPermit, routeRegistry, loadRoutes, redirectTo
    } = permitStore;
    const [permit, setPermit] = useState(new PermitFormValues());
    const {type} = useParams<{type: string}>();

    useEffect(() => {
        if(type) {
            if(routeRegistry.size < 1)
                loadRoutes();

            switch (type) {
                case 'carpool':
                    setPermit(p => ({
                        ...p,
                        permitTypeId: 2
                    }));
                    break;
                case 'vanpool':
                    setPermit(p => ({
                        ...p,
                        permitTypeId: 3
                    }));
                    break;
                default:
                    // param type does not valid, redirect not-found
                    redirectTo('not-found');
                    break;
            }
        }
    }, [type, loadRoutes, redirectTo, routeRegistry.size]);

    function handleFinalFormSubmit(values: PermitFormValues) {
        // check invalid?
        if(values.step === 6) {
            // remove select data if not selected
            let permit: PermitFormValues = {
                ...values,
                amTimes: values.amTimes.filter(item => item.isSelected === true)
                    .concat(values.am2Times.filter(item => item.isSelected === true)),
                pmTimes: values.pmTimes.filter(item => item.isSelected === true)
                    .concat(values.pm2Times.filter(item => item.isSelected === true)),
                // permitTypeId: permitTypeId
            } 
            createPermit(permit);
        } 
    }

    function handleChange(name: string|any, value: string|object|boolean ) {
        setPermit({
            ...permit,
            [name]: value
        });
    }
    
    function handleDropdownChange(e: React.ChangeEvent<HTMLInputElement>, result: any ) {
        const {name, value} = result;

        setPermit({
            ...permit,
            [name]: value
        });
    }

    function next() {
        setPermit({
            ...permit,
            step: permit.step + 1
        });
    }

    function prev() {
        setPermit({
            ...permit,
            step: permit.step - 1
        });
    }

    function goTo(step: number) {
        setPermit({
            ...permit,
            step: step
        });
    }

    return (
        <Segment basic>
            <PermitFormSteps 
                step={permit.step} 
                values={permit} 
                handleChange={handleChange} 
                handleDropdownChange={handleDropdownChange} 
                next={next} 
                prev={prev}
                goTo={(step: number) => goTo(step)}
                handleFinalFormSubmit={handleFinalFormSubmit}
            />
        </Segment>
    )
})